import {inlineError} from '@s-ui/decorators/lib'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class SubscribeToNewsletterUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Service} deps.getCurrentUserService
   * @param {Object} deps.requestFactory
   * @param {Error} deps.getSubscribeToNewsletterWithoutEmailError
   */
  constructor({repository, getCurrentUserService, requestFactory, getSubscribeToNewsletterWithoutEmailError}) {
    super({
      repository,
      getCurrentUserService,
      requestFactory,
      getSubscribeToNewsletterWithoutEmailError
    })

    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._requestFactory = requestFactory
    this._getSubscribeToNewsletterWithoutEmailError = getSubscribeToNewsletterWithoutEmailError
  }

  @inlineError
  async execute({email}) {
    if (!email)
      return Promise.reject(
        this._getSubscribeToNewsletterWithoutEmailError({
          message: 'Email is required'
        })
      )

    const userEntity = await this._getCurrentUserService.execute()

    const requestVO = this._requestFactory({email, userEntity})

    const [error, isSubscribed] = await this._repository.subscribeToNewsletter({
      requestVO
    })

    if (error) return Promise.reject(error)

    return isSubscribed
  }
}
